import { RemoteI9Type } from '@dtos/remote-i9-type';

export enum RemoteI9Flow {
    Section2,
    Section3
}

export function getRemoteI9FlowFromRemoteI9Type(type: RemoteI9Type): RemoteI9Flow | null {
    if (!type) {
        return null;
    }

    if (type.startsWith('SECTION2')) {
        return RemoteI9Flow.Section2;
    }

    if (type.startsWith('SECTION3')) {
        return RemoteI9Flow.Section3;
    }

    return null;
}



// WEBPACK FOOTER //
// ./src/models/remote-i9-flow.ts